<template>
  <el-dialog :title="formData.id ? '编辑系统用户' : '新增系统用户'" :visible.sync="_dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="600px">
    <el-form :model="formData" ref="listForm" :rules="rules">
      <el-form-item label="账号：" label-width="120px" prop="userName">
        <el-input v-model.trim="formData.userName" placeholder="请输入用户账号" :maxlength="20"></el-input>
      </el-form-item>

      <el-form-item label="姓名：" label-width="120px" prop="accountName">
        <el-input v-model.trim="formData.accountName" placeholder="请输入用户姓名" :maxlength="20"></el-input>
      </el-form-item>

      <el-form-item v-if="!formData.id" label="密码：" label-width="120px" prop="passWord">
        <el-input placeholder="请输入密码" type="password" v-model.trim="formData.passWord" :maxlength="32"></el-input>
      </el-form-item>

      <el-form-item label="角色：" prop="roleId" label-width="120px">
        <el-select v-model="formData.roleId" filterable remote :remote-method="loadRoleList" placeholder="请输入角色名称">
          <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item label="状态：" label-width="120px" prop="status" v-if="formData.id">
        <el-switch v-model="formData.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="冻结"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import md5 from "js-md5";

const defaultFormData = {
  userName: "",
  accountName: "",
  passWord: "",
  roleId: "",
  status: 1,
};

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
      required: true,
    },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  watch: {
    _dialogVisible(val) {
      if (val) {
        this.formData = Object.assign({}, defaultFormData);
        if (this.id) {
          this.loadSysUserDetail();
        }
        this.loadRoleList();
      }
    },
  },
  data() {
    const validatePassWord = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formData.passWord !== "") {
          if (this.formData.passWord.length < 4) {
            callback(new Error("密码请至少4位"));
          }
        }
        callback();
      }
    };
    return {
      formLoading: false,
      btnLoading: false,
      formData: Object.assign({}, defaultFormData),
      roleList: [],
      pager: {
        pageIndex: 1,
        pageSize: 99,
      },
      rules: {
        userName: [{ required: true, message: "请输入用户账号", trigger: "blur" }],
        accountName: [{ required: true, message: "请输入用户姓名", trigger: "blur" }],
        passWord: [{ validator: validatePassWord, trigger: "blur" }],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
    };
  },
  methods: {
    /**
     * 加载详情
     */
    loadSysUserDetail() {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + `/user/userDetail/${this.id}`,
        method: "GET",
      })
        .then(res => {
          this.formLoading = false;

          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.formData = res.body.data.data;
            } else {
              this.formData = {};
            }
          } else {
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 提交
     */
    handleSubmit() {
      this.$refs.listForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const params = Object.assign({}, this.formData, {
            passWord: md5(this.formData.passWord).toUpperCase(),
          });
          this.$http({
            url: this.formData.id ? global.apiUrl + "/user/editUser" : global.apiUrl + "/user/addUser",
            method: this.formData.id ? "PUT" : "POST",
            body: this.formData.id ? this.formData : params,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this._dialogVisible = false;
                this.$emit("onSuccess");
              } else {
              }
              setTimeout(() => {
                this.btnLoading = false;
              }, 500);
            })
            .catch(err => {
              this.btnLoading = false;

              console.error(err);
            });
        } else {
          this.btnLoading = false;
        }
      });
    },
    /**
     * 加载角色列表
     */
    loadRoleList(keyword = "") {
      this.$http({
        url: global.apiUrl + "/role/roleList",
        method: "GET",
        params: Object.assign(
          {},
          {
            roleName: keyword,
            pageIndex: this.pager.pageIndex,
            pageSize: this.pager.pageSize,
          }
        ),
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.roleList = res.body.data.data;
            } else {
              this.roleList = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 重置表单项，移除校验结果
     */
    closeDialog() {
      this.$refs.listForm.resetFields();
    },
  },
};
</script>
